import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import autocomplete, {AutocompleteResult} from "autocompleter/autocomplete";

import Fragment from "dce-fragments/lib/fragments/Fragment";
import findFragmentParent from "dce-fragments/lib/fragments/utils/findFragmentParent"

interface ScoringFieldProps {
    wireAction: string;
}



@Dce("ScoringField")
export default class ScoringField extends DceComponent<ScoringFieldProps> {

    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: ScoringFieldProps) {
        super(elem, props);

        //znalezienie parenta ktory jest fragmentem
        this.parentFragment = findFragmentParent(elem);

        let width = this.elem.getBoundingClientRect().width;

        console.log("W", width);

        let indicator = this.elem.querySelector('.scoring--ind') as HTMLElement;

        let percentGlobal = 0;
        this.elem.addEventListener('mousemove', e => {
            this.elem.classList.add("scoring-edit")
            let x = e.offsetX;

            console.log("POS X", x);

            let percent = Math.round((x / width)*100);
            indicator.style.left = ((x / width)*100) + "%"

            indicator.innerHTML = percent + "";

            percentGlobal = percent;
            console.log("PERCENT")

        });

        let c = false;

        this.elem.addEventListener('click', async e => {
            if(c){
                return;
            }
            c = true;
            let resp = await this.parentFragment.call(
                this.props.wireAction,
                {
                    scoring: percentGlobal
                }
            );
            c = false;
        })

        this.elem.addEventListener('mouseout', e => {
            this.elem.classList.remove("scoring-edit");
        })

    }

    onRemove() {

    }
}
